import { render, staticRenderFns } from "./_uploader_b64.vue?vue&type=template&id=3b82fdea"
import script from "./_uploader_b64.vue?vue&type=script&lang=js"
export * from "./_uploader_b64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports